import type { Vehicle as EstimateVehicleModel } from '@1po/1po-bff-fe-spec/generated/estimate/response/GetEstimate';
import type { Dispatch } from 'redux';
import { fetchKnownVehicle } from 'domains/catalog/fetchKnownVehicle';
import { toCatalogVehicleDetail } from 'domains/estimate/Estimate.mapper';

/**
 * Hydrates catalog context from an estimate/history vehicle via `/vehicles/select`
 * (does not consume VIN/VRN search rate limit).
 *
 * @param dispatch - Redux dispatch
 * @param vehicle - Estimate or history vehicle payload
 * @example
 * hydrateCatalogFromEstimateVehicle(dispatch, estimate.vehicle);
 */
export function hydrateCatalogFromEstimateVehicle(dispatch: Dispatch, vehicle: EstimateVehicleModel): void {
  fetchKnownVehicle(dispatch, toCatalogVehicleDetail(vehicle), false);
}
